var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.6364 0.136719C14.3895 0.136719 15 0.74724 15 1.50036C15 2.25347 14.3895 2.86399 13.6364 2.86399L1.36364 2.86399C0.61052 2.86399 -3.29197e-08 2.25347 0 1.50036C3.29197e-08 0.74724 0.610521 0.136719 1.36364 0.136719L13.6364 0.136719Z","fill":"#011949"}));
}

MinusInline.defaultProps = {"width":"15","height":"3","viewBox":"0 0 15 3","fill":"none"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
